






































import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { MobileGetter, User } from 'frontend/types';
import { DailyChallenge, DcFeaturedCourse, DcClassroom } from 'frontend/types/daily-challenges';

import { throttle } from 'frontend/utils/timing';

import DailyChallengeCalendar from 'frontend/views/dailyproblems/components/DailyChallengeCalendar.vue';
import DailyChallengeReminder from 'frontend/views/dailyproblems/components/DailyChallengeReminder.vue';
import DailyChallengeFeaturedCourse from 'frontend/views/dailyproblems/components/DcFeaturedCourse.vue';
import AddToClassrooms from 'frontend/views/dailyproblems/components/AddToClassrooms.vue';
import { safeWindow } from 'frontend/utils/window';

@Component({
  components: {
    DailyChallengeCalendar,
    DailyChallengeReminder,
    DailyChallengeFeaturedCourse,
    AddToClassrooms,
  },
  computed: {
    ...mapState('globals', ['user']),
    ...mapState('dailyChallenges', ['dc', 'classrooms']),
    ...mapGetters('dailyChallenges', ['featuredCourse']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('globals', ['isAuthenticated']),
  },
})
export default class DailyProblemBase extends Vue {
  private isAuthenticated!: boolean;
  private isMobile!: MobileGetter;
  private featuredCourse?: DcFeaturedCourse;
  private dc?: DailyChallenge;
  private classrooms!: DcClassroom[];
  private sidebarFixed: boolean = false;
  private user!: User;

  private get scrollHandler() {
    return throttle(() => {
      this.sidebarAffix();
    }, 16);
  }

  private sidebarAffix() {
    const scrollY = safeWindow()?.scrollY || 0;
    this.sidebarFixed = scrollY > 50;
  }

  private get isDailyProblemDetail(): boolean {
    return this.$route.name === 'daily_problems_problem';
  }

  private get isListingPage(): boolean {
    return this.$route.name === 'daily_problems_listing';
  }

  private get showReminderBox(): boolean {
    return !this.isDailyProblemDetail && this.isAuthenticated;
  }

  private get showFeaturedCourse() {
    return !this.isMobile(this.$mq) && this.isDailyProblemDetail;
  }

  private get enableAddToClassrooms(): boolean {
    return (
      this.isAuthenticated &&
      this.user.is_classroom_teacher &&
      !!this.classrooms &&
      this.classrooms.length > 0
    );
  }

  private get needSideBarAffix(): boolean {
    return this.isListingPage;
  }

  private mounted(): void {
    if (this.needSideBarAffix) {
      this.sidebarFixed = true;
      window.addEventListener('scroll', this.scrollHandler);
    }
  }

  private destroyed(): void {
    if (this.needSideBarAffix) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  }
}
